import React, { useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';

function ScrollToTop({ history, children }) {
  const pathName = useRef(history.location.pathname);
  useEffect(() => {
    const unlisten = history.listen(() => {
      // this will ignore scrolling to top when developer uses query push state via JS code ex: catalogue page and clicking on filter
      if (pathName.current !== history.location.pathname) {
        window.scrollTo(0, 0);
      }
      pathName.current = history.location.pathname;
    });

    return () => {
      unlisten();
    };

    // eslint-disable-next-line
  }, []);

  return <main>{children}</main>;
}

export default withRouter(ScrollToTop);
